import { resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-f8f4cc06"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "overlay"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_img = _resolveComponent("b-img");
  const _component_stroked_rounded_link_icon = _resolveComponent("stroked-rounded-link-icon");
  return _openBlock(), _createElementBlock("div", {
    style: _normalizeStyle($options.processedStyles),
    class: "image-element",
    onClick: _cache[0] || (_cache[0] = $event => $options.handleClick())
  }, [_createVNode(_component_b_img, {
    lazy: "",
    src: $props.image ?? '/assets/images/amazon-logo-transparent.svg',
    style: _normalizeStyle({
      maxWidth: `${$props.width}px`,
      maxHeight: `${$props.height}px`
    })
  }, null, 8, ["src", "style"]), $props.withOverlay ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_stroked_rounded_link_icon, {
    width: $props.width / 2,
    height: $props.height / 2,
    color: "#FFFFFF"
  }, null, 8, ["width", "height"])])) : _createCommentVNode("", true), $props.withFlag ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "flag",
    style: _normalizeStyle({
      ...$props.flagStyle,
      backgroundImage: `url(${$options.flag})`
    })
  }, null, 4)) : _createCommentVNode("", true)], 4);
}